import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFillDanger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "fill-danger",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M16.7708 2.09885C17.5472 2.3011 18.2108 2.79982 18.6162 3.48561L31.5895 25.4927C31.857 25.9482 31.9986 26.4655 32 26.9923C32.0014 27.5192 31.8625 28.0372 31.5974 28.494C31.3323 28.9509 30.9502 29.3307 30.4896 29.595C30.0291 29.8593 29.5065 29.9992 28.9741 30H3.02854C2.35991 29.9996 1.71019 29.7802 1.18068 29.3762C0.65117 28.9723 0.271611 28.4063 0.101167 27.7663C-0.0011486 27.3857 -0.0261743 26.9887 0.0275388 26.5985C0.0812512 26.2083 0.212637 25.8323 0.414092 25.4927L13.3843 3.48561C13.6479 3.03922 14.0234 2.66762 14.4745 2.40673C15.1686 2.00733 15.9943 1.89661 16.7708 2.09885Z",
				fill: "#EB6100"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M16 8.57144V19.7143",
				strokeWidth: 3,
				strokeLinejoin: "round",
				stroke: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M16 24.8578L16.0133 24.8576",
				strokeWidth: 4,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				stroke: "white"
			})
		]
	})
});
export default SvgFillDanger;
